import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { MenuItem } from '@mui/material';
import { useKabobMenuContext } from 'Views/Page/Content/Templates/WhatIfTemplate/Components/KabobMenu/KabobMenuContext';
import { DataValueMap, dataValueMapPropType } from 'Helpers/Testing';

const styles = theme => ({
  root: {
    fontSize: theme.typography.fontSizePt75Rem,
    fontWeight: theme.typography.fontWeightFacetMedium,
    color: theme.palette.facet.primaryGray,
  },
});

const KabobMenuItem = React.forwardRef((props, ref) => {
  const {
    key,
    classes,
    label,
    test,
    disabled,
    onClick,
    dataValueMap,
  } = props;

  const { setAnchorEl } = useKabobMenuContext();

  const handleClick = (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
    setAnchorEl(null); // Closes Kabob Menu
    onClick();
  };

  return (
    <MenuItem
      {...dataValueMap.append(DataValueMap.keyMap.dataElementSemantic, 'kabob-menu-item').build()}
      ref={ref}
      disabled={disabled}
      key={key}
      test={test}
      className={classes.root}
      onClick={handleClick}
    >
      {label}
    </MenuItem>
  );
});

KabobMenuItem.defaultProps = {
  key: null,
  disabled: false,
  test: null,
  dataValueMap: DataValueMap.init(),
};

KabobMenuItem.propTypes = {
  key: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  test: PropTypes.string,
  dataValueMap: dataValueMapPropType,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(KabobMenuItem);
